export default __webpack_public_path__ + "static/media/sparck-mountain-waves-grey.22fcfeda.png";